import { useReducer } from "react"
import { smsErrors, onFail, onRule, onStatusError } from "../../../UI/PopUp"
import Swal from "sweetalert2/dist/sweetalert2.js"

import formActions from "./actions"

import axios from "axios"

import {
  validateName,
  validatePhoneNumber,
  transformPhoneAfterMask,
  validateInn,
  validateCode,
  validatePhoneOperator,
} from "./validation"
import { getUrlParams, checkPromoter } from "./params"
import {
  getRecaptchaToken,
  resetRecaptcha,
  RECAPTCHA_ERROR_UA,
} from "../../../../helpers/recaptcha"

const {
  SEND_SMS,
  START_FETCH,
  FINISH_FETCH,
  FETCH_SUCCESS,
  FETCH_FAIL,
  CHANGE_NAME,
  CHANGE_INN,
  VALID_INN,
  CHECKED_INN,
  VALID_NAME,
  CHANGE_PHONE,
  VALID_PHONE,
  CHECKED_NAME,
  CHECKED_PHONE,
  TOGGLE_RULE,
} = formActions

const sourceOfPromoter = source => {
  switch (source) {
    case "admitad":
      return "Landing_ADWORK_Admitad"
    case "aff_sub":
      return "Landing_ADWORK_Letmeads"
    case "cash_cpa":
      return "Cash_CPA"
    default:
      return "Landing_ADWORK"
  }
}

const initialState = {
  fetch: false,
  sendSMS: false,
  success: false,
  fail: false,
  channel: checkPromoter(),
  name: { valid: false, value: "", checked: false },
  phone: { valid: false, value: "", checked: false },
  inn: { valid: false, value: "", checked: false },
  rule: true,
}

const checkChannel = () => {
  const { utm_source } = getUrlParams()
  //console.log("utm_source", utm_source)

  return utm_source
}

const checkMedium = () => {
  const { utm_medium } = getUrlParams()
  //console.log("utm_medium", utm_medium)

  return utm_medium
}

const checkСampaign = () => {
  const { utm_campaign } = getUrlParams()
  //console.log("utm_campaign", utm_campaign)

  return utm_campaign
}

const checkСontent = () => {
  const { utm_content } = getUrlParams()
  //console.log("utm_campaign", utm_campaign)

  return utm_content
}

const checkTerm = () => {
  const { utm_term } = getUrlParams()
  //console.log("utm_campaign", utm_campaign)

  return utm_term
}

const checkClickId = () => {
  const { click_id } = getUrlParams()
  //console.log("utm_campaign", utm_campaign)

  return click_id
}

const reducer = (state, action) => {
  switch (action.type) {
    case SEND_SMS:
      return { ...state, sendSMS: action.payload }
    case START_FETCH:
      return { ...state, fetch: true }
    case FINISH_FETCH:
      return { ...state, ...initialState }
    case FETCH_SUCCESS:
      return { ...state, fetch: false, success: true }
    case FETCH_FAIL:
      return { ...state, fetch: false, fail: true }

    case CHANGE_NAME:
      return { ...state, name: { ...state.name, value: action.payload } }
    case VALID_NAME:
      return {
        ...state,
        name: { ...state.name, valid: action.payload },
      }

    case CHANGE_INN:
      return { ...state, inn: { ...state.inn, value: action.payload } }
    case VALID_INN:
      return { ...state, inn: { ...state.inn, valid: action.payload } }
    case CHECKED_INN:
      return { ...state, inn: { ...state.inn, checked: true } }

    case CHECKED_NAME:
      return { ...state, name: { ...state.name, checked: true } }
    case CHECKED_PHONE:
      return { ...state, phone: { ...state.phone, checked: true } }

    case CHANGE_PHONE:
      return { ...state, phone: { ...state.phone, value: action.payload } }
    case VALID_PHONE:
      return {
        ...state,
        phone: { ...state.phone, valid: action.payload },
      }
    case TOGGLE_RULE:
      return {
        ...state,
        rule: !state.rule,
      }

    default:
      return state
  }
}

const useForm = (link, recaptchaRef) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const startSendSms = value => dispatch({ type: SEND_SMS, payload: value })

  //UI
  const startFetch = () => dispatch({ type: START_FETCH })
  const finishFetch = () => dispatch({ type: FINISH_FETCH })
  const fetchSuccess = () => dispatch({ type: FETCH_SUCCESS })
  const fetchFail = () => dispatch({ type: FETCH_FAIL })

  const toggleRule = () => dispatch({ type: TOGGLE_RULE })

  //Name
  const checkedName = () => dispatch({ type: CHECKED_NAME })

  const validName = isValidName =>
    dispatch({ type: VALID_NAME, payload: isValidName })
  const changeName = name => {
    dispatch({ type: CHANGE_NAME, payload: name })
    const isValidName = validateName(name)

    validName(isValidName)
  }

  //INN
  const checkedInn = () => dispatch({ type: CHECKED_INN })

  const validInn = isValidInn =>
    dispatch({ type: VALID_INN, payload: isValidInn })
  const changeInn = inn => {
    dispatch({ type: CHANGE_INN, payload: inn })

    const isValidInn = validateInn(inn)

    validInn(isValidInn)
  }

  //Phone
  const checkedPhone = () => dispatch({ type: CHECKED_PHONE })

  const validPhone = isValidPhone =>
    dispatch({ type: VALID_PHONE, payload: isValidPhone })
  const changePhone = phone => {
    dispatch({ type: CHANGE_PHONE, payload: phone })
    const normalPhone = transformPhoneAfterMask(phone)

    const isValidPhone = validatePhoneNumber(normalPhone)
    validPhone(isValidPhone)
  }

  const onSend = async () => {
    try {
      const { phone, inn, name, rule, channel } = state
      const { id, source } = channel
      ///Transform form after mask
      const normalPhone = transformPhoneAfterMask(phone.value)

      //Validate fileds
      const isValidPhone = validatePhoneNumber(normalPhone)
      const isValidName = validateName(name.value)
      const isValidInn = validateInn(inn.value)
      const isValidOperator = validatePhoneOperator(normalPhone)

      checkedPhone()
      checkedInn()
      checkedName()

      //Set fields
      validPhone(isValidPhone && isValidOperator)
      validName(isValidName)
      validInn(isValidInn)

      if (isValidPhone && isValidName && isValidInn && isValidOperator) {
        if (!rule) {
          onRule()
          return
        }

        const phoneFormated = phone.value.replace(/[\s()-]/gi, "")

        if (
          phoneFormated === "+380500000000" ||
          phoneFormated === "+380957027817"
        ) {
          sendDataToServer()
        } else {
          send_status_to_db(
            normalPhone,
            name.value,
            inn.value,
            "Cash landing",
            "FAILED"
          )

          startSendSms(true)
        }
      }
    } catch (error) {
      console.log("err", error)
    }
  }

  const sendDataToServer = async () => {
    const { phone, inn, name, rule, channel } = state
    const { id, source } = channel
    ///Transform form after mask
    const normalPhone = transformPhoneAfterMask(phone.value)
    const utmSource = checkChannel()
    const utmMedium = checkMedium()
    const utmСampaign = checkСampaign()
    const utmContent = checkСontent()
    const utmTerm = checkTerm()
    const clickId = checkClickId()
    startFetch()
    try {
      const res = await axios.post(
        "https://refinance.tascombank.ua/api/admitad",
        {
          name: name.value,
          phone: normalPhone,
          inn: inn.value,
          product: 78,
          channel: id ? id : "landing",
          source: source ? sourceOfPromoter(source) : "Cash_CPA",
          utm_content: utmContent ? utmContent : "landing",
          utm_source: utmSource ? utmSource : "landing",
          utm_medium: utmMedium ? utmMedium : "landing",
          utm_campaign: utmСampaign ? utmСampaign : "landing",
          utm_term: utmTerm ? utmTerm : "landing",
          click_id: clickId ? clickId : "landing",
          login: "CPA",
        }
      )
      //console.log(res)
      if (res.status === 201 || res.status == 200) {
        await send_status_to_db(
          normalPhone,
          name.value,
          inn.value,
          "Cash landing",
          "SUCCESS"
        )

        window.location.href = "https://tascombank.ua/promo/cashnowatm/typ"
        finishFetch()
      } else {
        send_status_to_db(
          normalPhone,
          name.value,
          inn.value,
          "Cash landing",
          "FAILED"
        )
        fetchFail()
      }
    } catch (error) {
      console.log("error", error)
      finishFetch()
      fetchFail()
      send_status_to_db(
        normalPhone,
        name.value,
        inn.value,
        "Cash landing",
        "FAILED"
      )
    }
  }

  const sendSMSReq = async () => {
    const smsLink = "https://tascombank.ua/api/sms/send"
    const normalPhone = transformPhoneAfterMask(state.phone.value)

    let token = null
    try {
      token = await getRecaptchaToken(recaptchaRef)
    } catch (err) {
      console.error("reCAPTCHA execute error", err)
    }

    if (!token) {
      Swal.showValidationMessage(RECAPTCHA_ERROR_UA)
      resetRecaptcha(recaptchaRef)
      return
    }

    try {
      return await axios
        .post(smsLink, {
          phoneNumber: normalPhone,
          source: "cashnowatm",
          token,
        })
        .then(response => {
          return response.data.timeout ? response.data.timeout : null
        })
        .catch(error => {
          if (
            error.response &&
            smsErrors.hasOwnProperty(error.response.status)
          ) {
            if (error.response.status == 452) {
              send_status_to_db(
                normalPhone,
                state.name.value,
                state.inn.value,
                "Cash landing",
                "REPEATED"
              )
            }

            onStatusError(state.phone.value, error.response.status, smsContext)
          } else {
            onFail()
            send_status_to_db(
              normalPhone,
              state.name.value,
              state.inn.value,
              "Cash landing",
              "FAILED"
            )
          }
        })
    } finally {
      resetRecaptcha(recaptchaRef)
    }
  }

  const reSendSmsReq = async () => {
    const smsLinkReSend = "https://tascombank.ua/api/sms/resend"
    const normalPhone = transformPhoneAfterMask(state.phone.value)

    let token = null
    try {
      token = await getRecaptchaToken(recaptchaRef)
    } catch (err) {
      console.error("reCAPTCHA execute error", err)
    }

    if (!token) {
      Swal.showValidationMessage(RECAPTCHA_ERROR_UA)
      resetRecaptcha(recaptchaRef)
      return
    }

    try {
      return await axios
        .post(smsLinkReSend, {
          phoneNumber: normalPhone,
          source: "cashnowatm",
          token,
        })
        .then(() => {
          return true
        })
        .catch(error => {
          if (
            error.response &&
            smsErrors.hasOwnProperty(error.response.status)
          ) {
            if (error.response.status === 454) {
              send_status_to_db(
                normalPhone,
                state.name.value,
                state.inn.value,
                "Cash landing",
                "REPEATED"
              )
              onStatusError(state.phone.value, 454, smsContext)
            } else {
              onStatusError(
                state.phone.value,
                error.response.status,
                smsContext
              )
            }
          } else {
            onFail()
            send_status_to_db(
              normalPhone,
              state.name.value,
              state.inn.value,
              "Cash landing",
              "FAILED"
            )
          }
        })
    } finally {
      resetRecaptcha(recaptchaRef)
    }
  }

  const confirmSmsReq = async code => {
    const smsLinkConfirm = "https://tascombank.ua/api/sms/confirm"
    const normalPhone = transformPhoneAfterMask(state.phone.value)
    try {
      if (!validateCode(code)) {
        onStatusError(state.phone.value, 453, smsContext)
      } else {
        return await axios
          .post(smsLinkConfirm, {
            code,
            phoneNumber: normalPhone,
            source: "cashnowatm",
          })
          .then(() => {
            startSendSms(false)
            sendDataToServer()
          })
          .catch(error => {
            if (
              error.response &&
              smsErrors.hasOwnProperty(error.response.status)
            ) {
              Swal.showValidationMessage(smsErrors[error.response.status])
              send_status_to_db(
                normalPhone,
                state.name.value,
                state.inn.value,
                "Cash landing",
                "FAILED"
              )
            } else {
              onFail()
              send_status_to_db(
                normalPhone,
                state.name.value,
                state.inn.value,
                "Cash landing",
                "FAILED"
              )
            }
          })
          .finally(() => {
            channel_landing_otp(normalPhone)
          })
      }
    } catch (err) {
      console.error(err)
      onFail()
      send_status_to_db(
        normalPhone,
        state.name.value,
        state.inn.value,
        "Cash landing",
        "FAILED"
      )
    }
  }

  const channel_landing_otp = async (phone = null) => {
    try {
      if (!phone) {
        console.error("channel_landing_otp error: Phone is not exist")
        return
      }

      const data = {
        channel: "cashnowatm",
        mobilePhone: phone,
      }

      await axios.post(
        "https://forms.tascombank.ua/api/v1/lending-channel",
        data
      )
    } catch (err) {
      console.error("Error channel_landing_otp", err)
    }
  }

  const log_form_submit = async () => {
    const { phone, name } = state

    try {
      if (!phone) {
        console.error("log_form_submit error: Phone is not exist")
        return
      }

      const data = {
        source: "cashnowatm",
        phone: phone.value,
        name: name.value || "No name",
      }

      await axios.post("https://tascombank.ua/api/form-log", data)
    } catch (err) {
      console.error("Error log_form_submit", err)
    }
  }

  const send_status_to_db = async (
    phone = "",
    name = "",
    inn = "",
    source = "Cash landing",
    status = "FAILED"
  ) => {
    try {
      if (!phone) {
        console.error("send_status_to_db error: Phone is not exist")
        return
      }

      if (!source) {
        console.error("send_status_to_db error: Source is not exist")
        return
      }

      const utmMedium = checkMedium()
      const utmСampaign = checkСampaign()
      const utmSource = checkChannel()

      const data = {
        source: "Cash landing",
        phone: phone,
        name: name,
        status: status,
        inn: inn.toString(),
        utm_campaign: utmСampaign ? utmСampaign : "Cash landing",
        utm_medium: utmMedium ? utmMedium : "Cash landing",
        utm_source: utmSource ? utmSource : "Cash landing",
        date: Date.now(),
      }

      await axios.post("https://tascombank.ua/api/form-log", data)
    } catch (err) {
      console.error("Error send_status_to_db", err)
    }
  }

  const smsContext = {
    startSendSms,
    sendSMSReq,
    reSendSmsReq,
    confirmSmsReq,
  }

  return {
    state,
    smsContext,
    changeName,
    checkedName,
    toggleRule,
    changeInn,
    checkedInn,
    checkedPhone,
    changePhone,
    onSend,
  }
}

export default useForm
